import React, { Component } from 'react';
import './checkbox.css';
//import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { connect } from 'react-redux';
//import { layer } from '@fortawesome/fontawesome-svg-core';



class CheckBox extends Component {
    constructor(props) {
      super(props);
      // State is in reducers
        this.state = {
            active:false,
        };

  }

  // INNER METHOD
  toggleBox = () =>{
    var change = !this.state.active;
    this.setState({active:change});
    this.props.updateChange(change);
  }
  
  
  // ---------------------RENDER --------------------- 
  render() {
    var labelStyle = {color: this.props.config.color,background: this.props.config.background};

      return (
          <div className={"checkbox active-"+this.state.active} style={labelStyle} onClick={this.toggleBox.bind()}>
            <div className="inputWrapper">
              <input type="checkbox" onChange={this.toggleBox.bind()} checked={this.state.active} />
            </div>
            <label className="text">{this.props.config.text}</label>
          </div>
      );
  }
}
  
const mapStateToProps = (state) => {    
  return {  
    
  } 
}
const mapDispatchToProps = (dispatch) => {
  return {
  } 
} 

export default connect(mapStateToProps, mapDispatchToProps)(CheckBox);
  